export const minNumberOfLetters  = 3;